import { Checkbox, ListItem, ListItemText } from "@mui/material"

const PlayerEventsListItem = ({ eventType, eventKey, eventValue, checked, onChange }) => (
    <ListItem
        secondaryAction={
            eventType && <Checkbox
                edge="end"
                checked={checked}
                onChange={() => onChange(eventType, eventKey)}
            />
        }
    >
        <ListItemText primary={`${eventKey} = ${eventValue}`} />
    </ListItem>
)

export default PlayerEventsListItem
